import type { LessonResult } from '../types';
import { useEnterAction } from '../lib/useEnterAction';

interface MentalImagerySummaryProps {
  result: LessonResult;
  onRepeat: () => void;
  onBack: () => void;
}

export default function MentalImagerySummary({
  result,
  onRepeat,
  onBack,
}: MentalImagerySummaryProps) {
  useEnterAction(onRepeat);

  const allCompleted = result.rounds.every((r) => r.completed);
  const hadMistakes = result.mistakes > 0;

  return (
    <div className="mx-auto flex w-full max-w-xl flex-col gap-8 animate-fade-in-up text-center">
      <header>
        <p className="text-xs font-medium tracking-[0.2em] uppercase text-stone-400 dark:text-stone-500">
          Øvelse afsluttet
        </p>
        <h1 className="mt-3 text-3xl font-light text-strong">
          Imaginær skrivning
        </h1>
      </header>

      <p className="text-sm leading-relaxed text-muted">
        {allCompleted
          ? hadMistakes
            ? 'Du gennemførte alle tre runder. Fejl er en del af læringen — det vigtige var pausen før fingrene.'
            : 'Du gennemførte alle tre runder med ro i kroppen. God mental forberedelse.'
          : 'Du stoppede undervejs. Næste gang kan du tage hele rejsen — se, blink, lyt.'}
      </p>

      <p className="text-xs text-faint">
        Ingen hastighed blev målt. Næste gang får du ti nye korte ord med bred
        bogstav-dækning.
      </p>

      <div className="flex flex-col gap-2 sm:flex-row">
        <button
          type="button"
          autoFocus
          onClick={onRepeat}
          className="flex-1 rounded-full border border-stone-300 bg-stone-50 px-4 py-3 text-sm font-medium text-stone-800 transition hover:bg-stone-100 dark:border-stone-600 dark:bg-stone-800/60 dark:text-stone-100 dark:hover:bg-stone-800"
        >
          Ny øvelse
        </button>
        <button
          type="button"
          onClick={onBack}
          className="flex-1 rounded-full px-4 py-3 text-sm font-medium text-muted transition hover:text-strong"
        >
          Tilbage til oversigt
        </button>
      </div>
      <p className="text-xs text-faint">Enter: ny øvelse</p>
    </div>
  );
}
